module.exports = __webpack_public_path__ + "static/img/logo.f4f963cc.png";